export default __webpack_public_path__ + "static/media/Letters2_05.3280fbcd.png";